export default "__VITE_ASSET__p3vY_UO3__"